module.exports = __webpack_public_path__ + "img/Flag_of_Cambodia.db440556.svg";